import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockTitle',
  props: {
    title: null,
    moduleIndex: null
  },
  setup(__props: any) {

const props = __props as {
	title: string | null | undefined;
	moduleIndex: number;
};



const showTitle = computed(() => !(props.title === null || props.title === undefined || props.title === ''));

return { __sfc: true,props, showTitle }
}

})